import getAllInteractions from 'services/apiHelpers/getAllInteractions';

let lastInteractionSeen;

const isLastInteraction = id => {
  const allInteractions = getAllInteractions() as any;
  return allInteractions[allInteractions.length - 1] === id;
};

const setLastInteractionSeen = (value: boolean) => {
  if (!lastInteractionSeen) {
    lastInteractionSeen = value;
  }
};

const getLastInteractionSeen = () => lastInteractionSeen;

export default isLastInteraction;
export { setLastInteractionSeen, getLastInteractionSeen };
